import React from 'react'
import TopBar from '../components/TopBar.jsx'
import Footer from '../components/Footer'

const Whitepaper = () => {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--bg-primary)' }}>
      <TopBar />

      <main className="flex-1 px-4 sm:px-6 lg:px-10 py-6 lg:py-10 max-w-5xl mx-auto">
        <section
          className="rounded-2xl shadow-lg p-6 sm:p-8 lg:p-10"
          style={{ background: 'var(--card-bg)', border: '1px solid var(--card-border)' }}
        >
          <header className="mb-6 sm:mb-8 mt-10 text-center">
            <h1 className="text-3xl sm:text-4xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
              FlazePad Whitepaper v1.0
            </h1>
            <p className="text-sm sm:text-base" style={{ color: 'var(--text-secondary)' }}>
              Fair Launch Token Infrastructure on BNB Chain
            </p>
            <p className="text-xs sm:text-sm mt-1" style={{ color: 'var(--text-secondary)', opacity: 0.8 }}>
              Version 1.0 &nbsp;|&nbsp; Last Updated March 2026 &nbsp;|&nbsp; © 2026 FlazePad
            </p>
          </header>

          <section className="mb-6 sm:mb-8">
            {/* <h2 className="text-xl sm:text-2xl font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
              Table of Contents
            </h2> */}
            {/* <ol className="list-decimal list-inside space-y-1 text-sm sm:text-base" style={{ color: 'var(--text-secondary)' }}>
              <li>Introduction</li>
              <li>Platform Overview</li>
              <li>Token Launch Lifecycle</li>
              <li>Standard Token Parameters</li>
              <li>Fair Launch Model</li>
              <li>Why Launch on FlazePad</li>
              <li>Liquidity Management</li>
              <li>Fee Structure</li>
              <li>Migration Reward</li>
              <li>Security Design</li>
              <li>Risk Disclosure</li>
              <li>Platform Disclaimer</li>
              <li>Example Token Launch Walkthrough</li>
              <li>Conclusion</li>
            </ol> */}
          </section>

          <section className="space-y-5 sm:space-y-6 text-sm sm:text-base" style={{ color: 'var(--text-secondary)' }}>
            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                1. Introduction
              </h2>
              <p>
                FlazePad is a fair launch token platform built on BNB Chain designed to simplify token creation while
                promoting transparency and predictable launch mechanics. The platform enables creators to deploy tokens
                using standardized smart contract templates that enforce fixed supply, renounced ownership and permanent
                liquidity burn mechanisms. FlazePad operates purely as technical infrastructure. It does not issue tokens,
                endorse projects or provide investment advice.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                2. Platform Overview
              </h2>
              <p>
                FlazePad provides infrastructure for launching tokens using bonding curve price discovery, automated
                liquidity migration and permanent liquidity burn. All launch activity occurs through publicly verifiable
                blockchain transactions.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                3. Token Launch Lifecycle
              </h2>
              <p>The typical token launch lifecycle on FlazePad is:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Token Deployment</li>
                <li>Bonding Curve Trading</li>
                <li>Liquidity Threshold Reached (18 BNB)</li>
                <li>Automatic Migration to PancakeSwap</li>
                <li>Open Market Trading</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                4. Standard Token Parameters
              </h2>
              <p>
                Tokens launched through FlazePad use a fixed supply model of one billion tokens. Minting is disabled after
                deployment. Token taxes are zero percent. Ownership is renounced following migration and one hundred percent
                of LP tokens are burned.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                5. Fair Launch Model
              </h2>
              <p>
                FlazePad uses a fair launch structure where token distribution occurs through open market participation.
                The platform does not require private sales, presales or predetermined team allocations.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                6. Why Launch on FlazePad
              </h2>
              <p>
                FlazePad provides transparent launch mechanics, predictable contract parameters, fair distribution and
                permanent liquidity commitment. The platform is designed to reduce technical barriers for creators while
                improving transparency for market participants.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                7. Liquidity Management
              </h2>
              <p>
                Liquidity generated through bonding curve trading automatically migrates to PancakeSwap when eighteen BNB
                is collected. Liquidity provider tokens are burned permanently and liquidity becomes locked within the
                decentralized exchange pool.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                8. Fee Structure
              </h2>
              <p>
                The base token deployment fee is 0.005 BNB. Optional featured launch promotion costs 0.01 BNB and the privacy
                feature costs 0.01 BNB. Pre‑migration trading fees are one percent for buy transactions and one percent for
                sell transactions. Fee allocation distributes forty percent to creator rewards, fifty percent to protocol
                revenue and ten percent to community rewards.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                9. Migration Reward
              </h2>
              <p>
                When the bonding curve completes a creator migration reward is distributed equal to one percent of the bonding
                curve funds collected. If eighteen BNB is collected the creator receives 0.18 BNB.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                10. Security Design
              </h2>
              <p>
                FlazePad token contracts remove common risk factors by disabling minting after deployment and excluding blacklist
                functions, trading pause mechanisms and adjustable tax controls.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                11. Risk Disclosure
              </h2>
              <p>
                Participation in token launches involves risk. Token prices may fluctuate significantly and market demand cannot be
                guaranteed. Blockchain transactions are irreversible and smart contracts may contain unforeseen vulnerabilities.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                12. Platform Disclaimer
              </h2>
              <p>
                FlazePad provides infrastructure only and does not issue or promote tokens. Tokens launched through FlazePad are
                created by independent users. Participants should conduct independent research before interacting with any token.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                13. Example Token Launch Walkthrough
              </h2>
              <p>
                A typical launch on FlazePad follows a clear sequence. A creator deploys a token using the platform interface.
                Users begin buying and selling through the bonding curve model. When the bonding curve collects eighteen BNB the
                system automatically migrates liquidity to PancakeSwap and creates a trading pair. Liquidity provider tokens are
                burned permanently and the token becomes freely tradable on the open market.
              </p>
            </div>

            <div>
              <h2 className="text-lg sm:text-xl font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
                14. Conclusion
              </h2>
              <p>
                FlazePad provides transparent infrastructure for fair launch token creation on BNB Chain through bonding curves,
                automated liquidity migration and permanent liquidity burn.
              </p>
            </div>
          </section>
        </section>
      </main>

      <Footer />
    </div>
  )
}

export default Whitepaper

